import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { IS_WEB } from "@common/utils/mobileUtils"
import { hasRole } from "@data/utility/ability"
import { findItemInListWithId } from "@data/utility/dataUtils"
import { formatCalendarMoment } from "@data/utility/Utils"
import { LinearGradient } from "expo-linear-gradient"
import React from "react"
import { TouchableOpacity, View } from "react-native"
import { IconButton } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { useSelector } from "react-redux"
import AvatarM from "../../../common/components/avatar/AvatarM"
import { DoneChip } from "../../activity/read/DoneChip"
import { TodoActivityBadges } from "./TodoActivityBadges"

export const getActivityType = (activity) => {
    const activityTemplates = useSelector(
        (state) => state.data.staticData?.activity_templates
    )

    const activityTemplate = findItemInListWithId(
        activity?.activity_template_id,
        activityTemplates
    )
    const formData = activityTemplate?.steps
    return formData?.find((step) => step.type === "photo") ? "photo" : "audio"
}

export function ActivityInfosIcons(props) {
    const large = props.large ?? false

    const mediaCount = props.activity?.media_count
    const isFinished = !!props.activity?.finished_at

    const activityType = getActivityType(props.activity)

    return (
        !isFinished && mediaCount > 0 && (
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    ...props.style,
                }}
            >
                <View
                    style={{
                        alignItems: "center",
                        flexDirection: "row",
                    }}
                >
                    <LinearGradient
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            alignSelf: "flex-end",
                            paddingVertical: 2,
                            paddingHorizontal: 4,
                            marginHorizontal: 0,
                            borderRadius: 6,
                        }}
                        colors={[theme.colors.primary, theme.colors.primary]}
                    >
                        <FontAwesome5
                            name={
                                activityType === "photo"
                                    ? "camera"
                                    : "microphone"
                            }
                            color={theme.colors.white}
                            solid
                            size={large ? 16 : 12}
                        />
                        <TextM
                            color={theme.colors.white}
                            fontWeight={"SemiBold"}
                            style={{ marginLeft: 4 }}
                            fontSize={large ? 14 : 10}
                        >
                            {mediaCount ?? 0}
                        </TextM>
                    </LinearGradient>
                </View>
            </View>
        )
    )
}

function DragAndDropHandle(props) {
    const height = props.height || 50

    const table = Array.from(Array(Math.round(height / 3.6)).keys())

    return table?.map((item, index) => (
        <View
            key={index}
            style={{
                width: 4,
                height: 4,
                borderRadius: 2,
                margin: 1.4,
                backgroundColor: theme.colors.white,
                opacity: 0.6,
            }}
        />
    ))
}

export const RealizationsListItemContent = (props) => {
    const {
        activity,
        schoolSubject,
        color = theme.colors.primary,
        noBorder,
        todo = false,
        user,
        student,
        onPressSwipe,
        dragButton,
        style,
        updatedActivityEventData,
        currentUser,
        highlighted = false,
        highlightColor = null,
        noOptions = false,
        noDragAndDrop = false,
        currentActivityId = null,
        // Optional pill stacked above the duration badge — used by Sam
        // Prescription to mark an activity that carries a prerequisite QCM.
        extraBadge = null,
        // Hides the spent/estimated time badge. Sam Prescription only: there
        // the tutor decides what to send, and time spent on an activity the
        // student hasn't opened yet says nothing. The student's own todo keeps
        // it, hence a prop rather than dropping the badge outright.
        hideDuration = false,
    } = props

    const activityType = getActivityType(activity)

    return (
        <View
            style={{
                width: "100%",
                flexDirection: "row",
                ...style,
            }}
        >
            {student && currentActivityId === activity?.id && (
                <View
                    style={{
                        position: "absolute",
                        top: -8,
                        left: -4,
                        zIndex: 1,
                        elevation: 1,
                    }}
                >
                    <AvatarM user={student} size={32} />
                </View>
            )}
            <View
                style={{
                    width: IS_WEB ? 16 : 10,
                    backgroundColor: color,
                    borderTopLeftRadius: 9,
                    borderBottomLeftRadius: 9,
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {!!todo && IS_WEB && (
                    <TouchableOpacity
                        onPressIn={dragButton}
                        style={{
                            height: 50,
                            alignSelf: "center",
                            flexWrap: "wrap",
                            flexDirection: "column",
                            marginTop: 4,
                        }}
                    >
                        {!noDragAndDrop && <DragAndDropHandle height={50} />}
                    </TouchableOpacity>
                )}
            </View>
            <View
                style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignContent: "center",
                    flex: 1,
                    paddingTop: 5,
                    paddingBottom: 5,
                    paddingLeft: 5,
                    backgroundColor: highlighted
                        ? highlightColor || theme.colors.linkLighter
                        : theme.colors.white,
                    borderTopRightRadius: 9,
                    borderBottomRightRadius: 9,
                }}
            >
                <View
                    style={{
                        paddingLeft: 5,
                        flex: 1,
                        justifyContent: "center",
                        marginVertical: 5,
                    }}
                >
                    <TextM
                        fontSize={12}
                        fontWeight={"SemiBold"}
                        color={theme.colors.grey}
                        wrap
                    >
                        {activity?.material?.title ?? activity?.title}
                    </TextM>
                    {(!noBorder || todo) && (
                        <View
                            style={{
                                alignItems: "center",
                                flexDirection: "row",
                                marginRight: 3,
                                marginTop: 2,
                            }}
                        >
                            <IconImageM
                                uri={schoolSubject?.icon}
                                width={9}
                                style={{
                                    marginRight: 4,
                                }}
                            />
                            <TextM
                                fontWeight="Light"
                                color={schoolSubject?.color}
                                style={{}}
                                fontSize={9}
                            >
                                {activity?.student_chapter?.chapter?.name
                                    ? activity?.student_chapter?.chapter?.name
                                    : schoolSubject?.name}
                            </TextM>
                        </View>
                    )}
                </View>

                <View
                    style={{
                        justifyContent: "flex-end",
                        position: "relative",
                    }}
                >
                    {!todo ? (
                        <View style={{ alignItems: "flex-end" }}>
                            <TextM
                                fontWeight="Regular"
                                fontSize={8}
                                wrap
                                color={theme.colors.grey}
                                style={{
                                    marginRight: 10,
                                    textAlign: "center",
                                }}
                            >
                                {formatCalendarMoment(activity?.finished_at)}
                            </TextM>
                            <DoneChip
                                count={0}
                                status={activity?.status}
                                style={{
                                    marginTop: 5,
                                    alignSelf: "flex-end",
                                    marginRight: 10,
                                }}
                                noText
                            />
                        </View>
                    ) : (
                        <View
                            style={{
                                alignItems: "flex-end",
                                marginRight: 10,
                                marginVertical: 2,
                            }}
                        >
                            {hasRole(currentUser, "tutor") && (
                                <ActivityInfosIcons
                                    activity={activity}
                                    activityType={activityType}
                                    updatedActivityEventData={
                                        updatedActivityEventData
                                    }
                                    style={{
                                        marginBottom: 2,
                                        marginRight:
                                            !!todo &&
                                            !noOptions &&
                                            hasRole(user, "student")
                                                ? 30
                                                : 0,
                                    }}
                                />
                            )}
                            {extraBadge}
                            {!hideDuration && (
                                <TodoActivityBadges
                                    activity={activity}
                                    updatedActivityEventData={
                                        updatedActivityEventData
                                    }
                                    noDifficulty
                                    custom
                                />
                            )}
                        </View>
                    )}
                </View>

                {!!todo && !noOptions && !activity?.finished_at && hasRole(user, "student") && (
                    <IconButton
                        icon={"ellipsis-h"}
                        iconColor={theme.colors.light}
                        containerColor={theme.colors.transparent}
                        size={24}
                        style={{
                            position: "absolute",
                            right: 0,
                            top: -5,
                        }}
                        onPress={onPressSwipe}
                    />
                )}
            </View>
        </View>
    )
}
